import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IAccountDetailsDTO } from '../../api/accounts.dao';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { AccountList } from './_account-list/accounts-list';
import { AccountsVM } from './accounts.viewmodel';
import { AccountsContext, connectAccountVM } from './account.context';
import { LOADING } from '../../constants/common-labels.constants';

interface IProps {
    accountsList: IAccountDetailsDTO[];
    isLoading: boolean;
    searchQuery: string;
}

const AccountDisconnected = props => {
    if (props.isLoading && !props.accountsList) {
        return <div>
            <FormattedMessage
                {...LOADING}
                values={{
                    suffix: '...'
                }}
            />
        </div>;
    } else {
        return <AccountList />;
    }

};

const AccountConnected = connectAccountVM<IProps>(AccountDisconnected, vm => {
    return {
        accountsList: vm.getAccountsList(),
        isLoading: vm.isLoading,
        searchQuery: vm.getSearchQuery()
    };
});

const Accounts = moduleHost(AccountsVM, AccountsContext, AccountConnected);

export { Accounts };
